export function scrollToTopOnRefresh() {
	let scrollRestorationSetToManual = false;
	try {
		if ('scrollRestoration' in window.history) {
			history.scrollRestoration = 'manual';
			scrollRestorationSetToManual = true;
		}
	} catch (ex) { }

	if (!scrollRestorationSetToManual) {
		window.addEventListener('beforeunload', () => {
			window.scrollTo(0, 0);
		});
	}

	window.scrollTo(0, 0);
}
